import { render, staticRenderFns } from "./ConfigTaskForm.vue?vue&type=template&id=66225e20&scoped=true&"
import script from "./ConfigTaskForm.vue?vue&type=script&lang=js&"
export * from "./ConfigTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTaskForm.vue?vue&type=style&index=0&id=66225e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66225e20",
  null
  
)

export default component.exports